/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createFacilityType } from '../fn/facility-type/create-facility-type';
import { CreateFacilityType$Params } from '../fn/facility-type/create-facility-type';
import { FacilityType } from '../models/facility-type';
import { getFacilityTypes } from '../fn/facility-type/get-facility-types';
import { GetFacilityTypes$Params } from '../fn/facility-type/get-facility-types';
import { updateFacilityType } from '../fn/facility-type/update-facility-type';
import { UpdateFacilityType$Params } from '../fn/facility-type/update-facility-type';

@Injectable({ providedIn: 'root' })
export class FacilityTypeService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getFacilityTypes()` */
  static readonly GetFacilityTypesPath = '/api/facilityType';

  /**
   * Get Facility Types.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFacilityTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityTypes$Response(params?: GetFacilityTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityType>>> {
    return getFacilityTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Facility Types.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFacilityTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityTypes(params?: GetFacilityTypes$Params, context?: HttpContext): Observable<Array<FacilityType>> {
    return this.getFacilityTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FacilityType>>): Array<FacilityType> => r.body)
    );
  }

  /** Path part for operation `createFacilityType()` */
  static readonly CreateFacilityTypePath = '/api/facilityType';

  /**
   * Create Facility Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFacilityType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFacilityType$Response(params: CreateFacilityType$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityType>> {
    return createFacilityType(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Facility Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFacilityType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFacilityType(params: CreateFacilityType$Params, context?: HttpContext): Observable<FacilityType> {
    return this.createFacilityType$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityType>): FacilityType => r.body)
    );
  }

  /** Path part for operation `updateFacilityType()` */
  static readonly UpdateFacilityTypePath = '/api/facilityType/{facilityTypeId}';

  /**
   * Update Facility Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFacilityType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFacilityType$Response(params: UpdateFacilityType$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityType>> {
    return updateFacilityType(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Facility Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFacilityType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFacilityType(params: UpdateFacilityType$Params, context?: HttpContext): Observable<FacilityType> {
    return this.updateFacilityType$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityType>): FacilityType => r.body)
    );
  }

}
